(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection--brutal"] && !window.DesignMode) return;
  try {
    
  loadProducts();
  if (Shopify.designMode) {
    document.addEventListener('shopify:inspector:activate', loadProducts);
    document.addEventListener('shopify:section:load', loadProducts);
  }

  function loadProducts() {
    document.querySelectorAll('.js-cp3--products').forEach(async container => {
      const collectionID = container.dataset.collectionId;
      if (!collectionID) return;
      const data = await window.APP.queryStorefront(`
        query CollectionProducts {
          collection(id: "gid://shopify/Collection/${collectionID}") {
            products(first: ${ container.dataset.productCount }, filters: { available: true }) {
              nodes {
                onlineStoreUrl
                title
                featuredImage {
                  url
                }
              }
            }
          }
        }
      `);
      container.innerHTML = data.collection.products.nodes.reduce((html, pd) => {
        return html + window.APP.productGridItem(
          pd.onlineStoreUrl,
          pd.title,
          pd.featuredImage.url,
          container.dataset.sizes,
          container.dataset.srcsetWidths,
        );
      }, '');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection--simple"] && !window.DesignMode) return;
  try {
    
  loadProducts();
  if (Shopify.designMode) {
    document.addEventListener('shopify:inspector:activate', loadProducts);
    document.addEventListener('shopify:section:load', loadProducts);
  }

  function loadProducts() {
    document.querySelectorAll('.js-cp4--products').forEach(async container => {
      const collectionID = container.dataset.collectionId;
      if (!collectionID) return;
      const data = await window.APP.queryStorefront(`
        query CollectionProducts {
          collection(id: "gid://shopify/Collection/${collectionID}") {
            products(first: ${ container.dataset.productCount }, filters: { available: true }) {
              nodes {
                onlineStoreUrl
                title
                featuredImage {
                  url
                }
              }
            }
          }
        }
      `);
      container.innerHTML = data.collection.products.nodes.reduce((html, product) => {
        return html + window.APP.productGridItem(
          product.onlineStoreUrl,
          product.title,
          product.featuredImage.url,
          container.dataset.sizes,
          container.dataset.srcsetWidths,
        );
      }, '');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-styles"] && !window.DesignMode) return;
  try {
    
  document.querySelectorAll('.new-styles--products.splide').forEach(el => {
    new Splide(el, {
      speed: 500, // `window.APP.config.carouselTransitionDur` is too fast
      gap: '1px',
      pagination: false,
      drag: 'free',
      snap: true,
      mediaQuery: 'min',
      breakpoints: {
        769: { fixedWidth: `${100/5.2}%`, perMove: 5 },
        480: { fixedWidth: `${100/3.2}%`, perMove: 3 },
        0: { fixedWidth: `${100/2.2}%`, perMove: 2 },
      },
    }).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', lazyLoadVideos);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', lazyLoadVideos);
  }

  /**
   * @see <https://web.dev/lazy-loading-video/>
   */
  function lazyLoadVideos() {
    const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));

    if ('IntersectionObserver' in window) {
      const lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(video => {
          if (video.isIntersecting) {
            for (const source in video.target.children) {
              const videoSource = video.target.children[source];
              if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                videoSource.src = videoSource.dataset.src;
              }
            }
            video.target.load();
            video.target.classList.remove('lazy');
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
      lazyVideos.forEach(lazyVideo => lazyVideoObserver.observe(lazyVideo));
    }
  }

  } catch(e) { console.error(e); }
})();
})();
